import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  getAllGroup,
} from "./paramAPI";

const initialState = {
  data: [],
  data4: [],
  data2: [],
  data3: [],
  data4: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "param/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchDataGroup = createAsyncThunk(
  "param/fetchDataGroup",
  async (payload) => {
    const response = await getAllGroup(payload);
    return response;
  }
);

export const fetchParam = createAsyncThunk(
  "param/fetchParam",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchParam2 = createAsyncThunk(
  "param/fetchParam2",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchParam3 = createAsyncThunk(
  "param/fetchParam3",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchParam4 = createAsyncThunk(
  "param/fetchParam4",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchId = createAsyncThunk("param/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "param/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("param/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});
export const addParamItem = createAsyncThunk(
  "param/addParamItem",
  async (payload) => {
    const response = await createItem(payload);
    return response;
  }
);

export const editItem = createAsyncThunk("param/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});
export const removeById = createAsyncThunk(
  "param/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const paramSlice = createSlice({
  name: "param",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchDataGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDataGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.data4 = action.payload.data.data;
      })
      .addCase(fetchParam.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchParam.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchParam2.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParam2.fulfilled, (state, action) => {
        state.loading = false;
        state.data2 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchParam3.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParam3.fulfilled, (state, action) => {
        state.loading = false;
        state.data3 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchParam4.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchParam4.fulfilled, (state, action) => {
        state.loading = false;
        state.data4 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addParamItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addParamItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = paramSlice.actions;

export const selectData = (state) => state.param.data;
export const selectDataGroup = (state) => state.param.data4;
export const selectDataParam = (state) => state.param.data;
export const selectDataParam2 = (state) => state.param.data2;
export const selectDataParam3 = (state) => state.param.data3;
export const selectDataParam4 = (state) => state.param.data4;
export const selectId = (state) => state.param.dataId;
export const selectLoading = (state) => state.param.loading;
export const selectError = (state) => state.param.error;
export const selectPageNo = (state) => state.param.pageNo;
export const selectPageSize = (state) => state.param.pageSize;
export const selectTotalRecord = (state) => state.param.totalRecord;
export const selectSelected = (state) => state.param.selected;
export const selectResult = (state) => state.param.result;

export default paramSlice.reducer;
